import { render, staticRenderFns } from "./CompanyBulkInviteRfx.vue?vue&type=template&id=dfdecdcc"
import script from "./CompanyBulkInviteRfx.vue?vue&type=script&lang=js"
export * from "./CompanyBulkInviteRfx.vue?vue&type=script&lang=js"
import style0 from "./CompanyBulkInviteRfx.vue?vue&type=style&index=0&id=dfdecdcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports